import { useQuery } from '@tanstack/react-query'
import { useLocale } from 'gt-react'
import { useMemo } from 'react'
import { orpc } from '@/lib/orpcClient'
import { useModulesContext } from '@/providers/modules-provider'
import { type DatasetMenuItem, toDatasetMenuItems } from './dataset-menu'

/**
 * De datasets met een menuplek, in de taal van de app. Nooit een fout: zonder `dataset:read` geeft
 * de backend `[]`, en zonder integratiemodule wordt er niets gevraagd — de zijbalk hoort op geen
 * van beide te breken.
 */
export function useDatasetMenu(): DatasetMenuItem[] {
  const locale = useLocale()
  const { isModuleEnabled } = useModulesContext()
  const q = useQuery({
    ...orpc.integration.datasets.menu.queryOptions({ input: {} }),
    enabled: isModuleEnabled('integrations'),
    retry: false,
    throwOnError: false,
    staleTime: 5 * 60_000,
  })
  return useMemo(() => toDatasetMenuItems(q.data ?? [], locale), [q.data, locale])
}
